import { useSelector } from "react-redux";
import { RootState } from "store";
import { Auth } from "model/Auth";

export const useAuth = (): Auth => {
	return useSelector<RootState, Auth>(state => state.login.auth);
};

export default useAuth;